import { EmptyState } from '@efdigital/ll-xceed-v2/components/application/empty-state';
import { Spinner } from '@efdigital/ll-xceed-v2/components/application/spinner.gts';
import SessionCard from '@efdigital/ll-xceed-v2/components/coaching/coach/session-card.gts';
import type { CoachingCoachSessionsActionRequiredModel } from '@efdigital/ll-xceed-v2/routes/coaching/coach/sessions/action-required';
import CoachService from '@efdigital/ll-xceed-v2/services/coach';
import { toCoachSessionCardItems } from '@efdigital/ll-xceed-v2/utils/coaching/coach-session-card-items';
import type RouterService from '@ember/routing/router-service';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { Await } from '@warp-drive/ember';
import { pageTitle } from 'ember-page-title';

interface CoachingCoachSessionsActionRequiredSignature {
  Args: {
    model: CoachingCoachSessionsActionRequiredModel;
    controller: unknown;
  };
}

export default class CoachingCoachSessionsActionRequired extends Component<CoachingCoachSessionsActionRequiredSignature> {
  @service declare coach: CoachService;
  @service declare router: RouterService;

  get hasSessions(): boolean {
    return (
      this.args.model.pendingConfirmation.length > 0 ||
      this.args.model.actionRequired.length > 0
    );
  }

  refresh = () => {
    this.router.refresh('coaching.coach.sessions');
  };

  <template>
    {{pageTitle "Sessions"}}

    {{#if this.hasSessions}}
      {{#if @model.pendingConfirmation.length}}
        <div class="mb-4">
          <Await
            @promise={{toCoachSessionCardItems
              @model.pendingConfirmation
              this.coach
            }}
          >
            <:success as |sessions|>
              <div class="d-flex flex-column gap-4">
                {{#each sessions as |item|}}
                  <SessionCard
                    @session={{item.session}}
                    @coach={{@model.coach}}
                    @coachee={{item.coachee}}
                    @coachingConfig={{item.coachingConfig}}
                    @onChanged={{this.refresh}}
                  />
                {{/each}}
              </div>
            </:success>
            <:pending>
              <Spinner />
            </:pending>
          </Await>
        </div>
      {{/if}}

      {{#if @model.actionRequired.length}}
        <div class="mb-4">
          <Await
            @promise={{toCoachSessionCardItems
              @model.actionRequired
              this.coach
            }}
          >
            <:success as |sessions|>
              <div class="d-flex flex-column gap-4">
                {{#each sessions as |item|}}
                  <SessionCard
                    @session={{item.session}}
                    @coach={{@model.coach}}
                    @coachee={{item.coachee}}
                    @coachingConfig={{item.coachingConfig}}
                    @onChanged={{this.refresh}}
                  />
                {{/each}}
              </div>
            </:success>
            <:pending>
              <Spinner />
            </:pending>
          </Await>
        </div>
      {{/if}}
    {{else}}
      <EmptyState @message="Nothing needs your attention." />
    {{/if}}
  </template>
}
